module.exports = __webpack_public_path__ + "img/search3_p.64829f55.svg";